var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({class:[
    "cv-header-global-action",
    (_vm.carbonPrefix + "--header__action"),
    ( _obj = {}, _obj[(_vm.carbonPrefix + "--header__action--active")] = _vm.dataActive, _obj ) ],attrs:{"type":"button","aria-haspopup":"true","aria-controls":_vm.ariaControls,"aria-expanded":_vm.active ? 'true' : 'false',"id":_vm.uid},on:{"click":_vm.gaToggle,"focusout":_vm.gaFocusout}},_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }